export default {
  'rule-uppercase': 'Majuscule',
  'rule-lowercase': 'Minuscule',
  'rule-size': '8 caractères min',
  'rule-number': 'Chiffre',
};
